import { render, staticRenderFns } from "./InventarioDepartamento.view.vue?vue&type=template&id=7f1b7031"
import script from "./InventarioDepartamento.view.vue?vue&type=script&lang=js"
export * from "./InventarioDepartamento.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports